import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary, ErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { PluginButtonProps } from './PluginButton';

export const LazyPluginButton: FunctionComponent<PluginButtonProps> = (
  props,
) => {
  const PluginButton = useLazyComponent(
    () => import(/* webpackChunkName: "plugin-button" */ './PluginButton'),
    {
      preload: false,
      namedImport: 'PluginButton',
    },
  );
  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ecosystem',
          feature: 'Pup Header Buttons',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <PluginButton {...props} />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
